/** ngx-translate walks dotted keys into a nested object; we stash the original leaf here. */
export const TRANSLATION_LEAF = '_';

const OBJECT_PROPS = [TRANSLATION_LEAF, 'default', 'label', 'title', 'value', 'name'] as const;

/**
 * Copy for menu/title keys that Resources also uses as a dotted namespace.
 * Used when the dictionary value is an object and no leaf string was preserved.
 */
const LEAF_FALLBACKS: Readonly<Record<string, { en: string; sa: string }>> = {
  fieldCatalogue: { en: 'Fields Catalogue', sa: 'كتالوج الحقول' },
};

/**
 * Turns a TranslateService value into screen text.
 * Nested Resources rows under a title key (e.g. fieldCatalogue.clearOptions*) make
 * instant('fieldCatalogue') return an object, which the translate pipe prints as [object Object].
 */
export function translationDisplayText(
  value: unknown,
  key = '',
  lang?: string | null,
): string {
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (trimmed && trimmed !== '[object Object]' && trimmed !== key) {
      return value;
    }
  }

  if (value && typeof value === 'object' && !Array.isArray(value)) {
    const record = value as Record<string, unknown>;
    for (const prop of OBJECT_PROPS) {
      const inner = record[prop];
      if (typeof inner === 'string' && inner.trim()) {
        return inner;
      }
    }
  }

  const fallback = LEAF_FALLBACKS[key];
  if (fallback) {
    return isArabicLang(lang) ? fallback.sa : fallback.en;
  }

  return key;
}

function isArabicLang(lang?: string | null): boolean {
  const code = String(lang ?? 'en').toLowerCase();
  return code === 'sa' || code === 'ar';
}
